import { AfterViewInit, Component, Input, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SharedService } from '@shared/services/shared.service';
import { Retest } from 'app/models/retest/retest';
import { OregonWellDataService } from 'app/services/oregon-well-data.service';
import { RetestService } from 'app/services/retest-service';
import { DialogEditVoucherComponent } from '../vouchers/edit/voucher-edit-dialog';
import { DialogEditHouseholdComponent } from '../households/edit/household-edit-dialog';
import { EditSampleComponent } from '../well/samples/edit/edit-samples.component';
import { DialogEditRetestsComponent } from './edit/retests-edit-dialog';
import { ToastrService } from 'ngx-toastr';
import { DialogAddRetestsComponent } from './retests-add-dialog';
import { AuthService } from '@shared/auth/auth.service';

@Component({
  selector: 'list-retests',
  templateUrl: './list-retests.component.html',
  styleUrls: ['./list-retests.component.scss']
})
export class ListRetestsComponent implements AfterViewInit  {
  @Input('voucherId')
  voucherId: number = 0;
  @Input('householdId')
  householdId: number = 0;
  processing = false;
  pageSize = 10;
  resultSize: number = 0;
  modalWidth = '90%';
  searchResults: Retest[] = [];

  displayedColumns: string[] = ['id','orgininalSampleId', 'retestSampleId', 'voucherId', 'retestYear', 'retestQuarter', 'tier','dueBy','complete','completedDate','highestNitrate','action'];
  dataSource = new MatTableDataSource<Retest>(this.searchResults);
  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  filterTable(event: Event) {
    let value = (event.target as HTMLInputElement).value;
    this.dataSource.filter = value.trim().toLowerCase();
  }
    
  constructor(public dialog: MatDialog, public oregonWellDataService: OregonWellDataService, 
    public authService: AuthService, private toastr: ToastrService, 
    private sharedService: SharedService, public retestService: RetestService) {}

  ngAfterViewInit(): void {
    this.load();
  }

  load() {
    this.processing = true;

    if(this.voucherId > 0){ 
      this.retestService.getVoucherRetests(this.voucherId).subscribe(
        result => {
          this.searchResults = result;
          this.processing = false;
          this.resultSize = result.length;
        },
        error => {
          this.processing = false;
        },
        () => {
          this.dataSource = new MatTableDataSource<Retest>(this.searchResults);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        }
      );
    }
    else if(this.householdId > 0){
      this.retestService.getHouseholdRetests(this.householdId).subscribe(
        result => {
          this.searchResults = result;
          this.processing = false;
          this.resultSize = result.length;
        },
        error => {
          this.processing = false;
        },
        () => {
          this.dataSource = new MatTableDataSource<Retest>(this.searchResults);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        }
      );
    }
  }

  addRetest() {

    const dialogRef = this.dialog.open(DialogAddRetestsComponent, {
      width: '90%',
      data: this.voucherId > 0 ? this.voucherId : this.householdId
    });
    dialogRef.afterClosed().subscribe(result => {
        this.load();
    });
  }

  deleteRetest(id: number){
    

    this.sharedService.openConfirm("Are you sure you want to remove this scheduled retest?");
    this.sharedService.confirmed().subscribe(confirmed => {
      if (confirmed) {
        this.processing = true;this.retestService.deleteRetest(id).subscribe(
          result => {
            this.toastr.success("Retest deleted");
            this.load();
          },
          error => {
            this.toastr.error("Error deleting retest : " + error.message, "Error deleting retest  ");
            this.processing = false;
          },
          () => {
          }
        );
      }
    });
    
  }

  editRetest(id: number){
    const dialogRef = this.dialog.open(DialogEditRetestsComponent, {
      width: '90%',
      data: id
    });
    dialogRef.afterClosed().subscribe(result => {
        this.load();
    });
  }

  editVoucher(id: number){
    const dialogRef = this.dialog.open(DialogEditVoucherComponent, {
      width: '90%',
      data: id,
    });
    dialogRef.afterClosed().subscribe(result => {
      this.load();
    });
  }
  editHousehold(id: number){
    const dialogRef = this.dialog.open(DialogEditHouseholdComponent, {
      width: '90%',
      data: id,
    });
    dialogRef.afterClosed().subscribe(result => {
      this.load();
    });
  }
  editSample(id: number){
    const dialogRef = this.dialog.open(EditSampleComponent, {
      width: '90%',
      data: id
    });
    dialogRef.afterClosed().subscribe(result => {
        this.load();
    });
  }
}